import React, { useState } from 'react'
import { Modal, Box, Typography, Button } from '@mui/material'
import { usePostRequest } from '../../../shared/hooks/requests'
import { TENANT_ANALYTICS_ATTENDANCE_UPDATE } from '../../../shared/utils/urls'
import { useMessage } from '../../../shared/hooks/message'

export function UpdateDuplicates({ ids, onSuccess }) {
    const showMessage = useMessage()
    const updateDuplicates = usePostRequest()
    const [confirmOpen, setConfirmOpen] = useState(false)

    const handleConfirm = () => {
        setConfirmOpen(true)
    }

    const handleCancel = () => {
        setConfirmOpen(false)
    }

    const handleSubmit = async () => {
        setConfirmOpen(false)
        const { success } = await updateDuplicates.request({
            url: TENANT_ANALYTICS_ATTENDANCE_UPDATE,
            data: ids,
        })

        if (success) {
            showMessage('Successfully updated', 'success-msg')
            if (typeof onSuccess === 'function') {
                onSuccess()
            }
        }
    }

    return (
        <>
            <button
                onClick={handleConfirm}
                className="px-[15px] py-[10px] bg-main-100 text-white font-[500] rounded-[10px]"
                disabled={ids.length === 0}
            >
                Unduplicate
            </button>

            <Modal open={confirmOpen} onClose={handleCancel} className="flex items-center justify-center">
                <Box className="bg-white p-[20px] rounded-[10px] shadow-lg w-[300px] flex flex-col items-center gap-[15px]">
                    <Typography variant="h6" className="text-center">
                        Rostanham unduplicate qilmoqchimisiz?
                    </Typography>
                    <div className="flex gap-[10px]">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Ha
                        </Button>
                        <Button variant="outlined" color="error" onClick={handleCancel}>
                            Yo`q
                        </Button>
                    </div>
                </Box>
            </Modal>
        </>
    )
}
